export default [
  {
    path: '',
    component: () => import('@modules/AiTriage/components/AiTriageHostPage.vue'),
    meta: {
      title: 'AI Triage',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/ai-triage',
          title: 'AI Triage'
        }
      ]
    }
  }
];
